module.exports = __webpack_public_path__ + "img/202310_06.24ec3de3.jpg";